"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _Context = require("./Context");
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PricewatchSubscribeFormCancelButton = function PricewatchSubscribeFormCancelButton(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_Context.SubscribeContext),
    onCancel = _useContext.onCancel;
  return /*#__PURE__*/_react["default"].createElement(StyledButton, (0, _extends2["default"])({
    onClick: onCancel
  }, props), children);
};
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "PricewatchSubscribeFormCancelButton__StyledButton",
  componentId: "sc-ei83fg-0"
})(["color:#007aff;", ""], function (_ref2) {
  var functional = _ref2.functional;
  return !functional && "\n    width: 100%;\n    font-size: 14px;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    position: relative;\n    margin-top: 4px;\n\n    ".concat(function (_ref3) {
    var isMobile = _ref3.isMobile;
    return isMobile && (0, _styledComponents.css)(["font-size:16px;height:48px;"]);
  }, ";\n  ");
});
PricewatchSubscribeFormCancelButton.propTypes = {
  children: _propTypes["default"].string
};
PricewatchSubscribeFormCancelButton.defaultProps = {
  children: _localization.i18n.t('subscribe.cancel')
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(PricewatchSubscribeFormCancelButton);